import React from 'react';
import Button from '../Common/Button';
import styles from './scenes.module.scss';

// PC 壳：星星总量 + 规则 / 明细 / 兑换
export default function ScenesPc({
  balance,
  showExchangeBtn,
  showDynamic,
}) {
  const tabPage = (type) => {
    if (type === 1) {
      showDynamic && showDynamic({ starInstructionShow: true, starListShow: false });
    }
    if (type === 2) {
      showDynamic && showDynamic({ starListShow: true, starInstructionShow: false });
    }
  };

  const showExchange = () => {
    showDynamic && showDynamic({ exchangeModalShow: true });
  };

  return (
    <div className={styles.totalStarCon}>
      <div className={styles.left}>
        <img src={require('../../assets/img/star/star_total.png')} width="48" height="48" alt="" />
        <div className={styles.totalStarDesc}>
          <p className={styles.totalStarDescText}>星星总量</p>
          <p className={styles.totalStarDescNum}>{balance}</p>
        </div>
      </div>
      <ul className={styles.right}>
        <li>
          <span className={styles.regularBtn} onClick={() => tabPage(1)}>星星规则</span>
        </li>
        <li>
          <span className={styles.starDetailBtn} onClick={() => tabPage(2)}>星星明细</span>
        </li>
        {showExchangeBtn && (
          <li>
            <Button type="primary" onClick={showExchange}>星星兑换</Button>
          </li>
        )}
      </ul>
    </div>
  );
}
